import { request, requestToken, requestTokenImage } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/yantramanage`;

class YantraManageServices {
  async getYantraListData() {
    try {
      let action = API_ROUTE + `/yantralist-data`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.error("Errorin getYantraListData:", error);
      throw error;
    }
  }

  async UpdateYantraDataById(payload) {
    try {
      let action = API_ROUTE + `/update-yantralist-by_id`;
      const response = await requestTokenImage.post(action, payload);
      return response;
    } catch (error) {
      console.error("Errorin getYantraListData:", error);
      throw error;
    }
  }

}

export default YantraManageServices;

